module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box video-pop-box",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "video-pop",
    class: _vm.data.wrapPopIndex
  }, [_c('beast-video', {
    ref: "popVideo",
    attrs: {
      "wrap": _vm.data.wrapPopIndex,
      "width": _vm.videoWidth,
      "height": _vm.videoHeight,
      "poster": _vm.data.poster,
      "autoplay": true,
      "source": _vm.data.source,
      "controls": _vm.data.controls,
      "videoFormat": _vm.data.videoFormat,
      "muted": _vm.data.muted,
      "radius": _vm.radius,
      "playVideo": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "close-box",
    on: {
      "click": _vm.closeAction
    }
  }, [_c('div', {
    staticClass: "close"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26810880"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/video-pop.vue
// module id = 492
// module chunks = 1 5 13 19